<template>
  <div class="welfare">
    <!-- 开放的企业文化 -->
    <div class="culture">
      <div class="title">开放的企业文化</div>
      <!-- icon -->
      <div class="icon">
        <div>
          <img src="../../../assets/images/join/welfare/icon/icon_01.png" alt />
          <div>上班不打卡</div>
        </div>
        <div>
          <img src="../../../assets/images/join/welfare/icon/icon_02.png" alt />
          <div>五险一金</div>
        </div>
        <div>
          <img src="../../../assets/images/join/welfare/icon/icon_03.png" alt />
          <div>年度体检</div>
        </div>
        <div>
          <img src="../../../assets/images/join/welfare/icon/icon_04.png" alt />
          <div>技能培训</div>
        </div>
        <div>
          <img src="../../../assets/images/join/welfare/icon/icon_05.png" alt />
          <div>足球俱乐部</div>
        </div>
        <div>
          <img src="../../../assets/images/join/welfare/icon/icon_06.png" alt />
          <div>员工生日会</div>
        </div>
        <div>
          <img src="../../../assets/images/join/welfare/icon/icon_07.png" alt />
          <div>商业保险</div>
        </div>
        <div>
          <img src="../../../assets/images/join/welfare/icon/icon_08.png" alt />
          <div>过节礼品</div>
        </div>
        <div>
          <img src="../../../assets/images/join/welfare/icon/icon_09.png" alt />
          <div>羽毛球俱乐部</div>
        </div>
      </div>
    </div>
    <!-- 旅游 -->
    <div class="tour">
      <!-- 菜单 -->
      <div class="tourMenu">
        <div class="tourMenuList">
          <ul>
            <li
              v-for="(item, i) in tourMenuList"
              :key="i"
              @click="active = i, setTourList(i)"
            >{{item.name}}</li>
          </ul>
          <i class="selectLine"></i>
        </div>
        <span class="number">
          <strong>0{{active}}</strong>/
          <b>02</b>
        </span>
        <div class="switch" v-if=" tourList == 0 || tourList == 1 ">
          <span @click="prev(0)">
            <img src="../../../assets/images/company/left.png" alt />
          </span>
          <span @click="next(1)">
            <img src="../../../assets/images/company/right.png" alt />
          </span>
        </div>
        <div class="switch" v-if=" tourList == 2 || tourList == 3 ">
          <span @click="prev(2)">
            <img src="../../../assets/images/company/left.png" alt />
          </span>
          <span @click="next(3)">
            <img src="../../../assets/images/company/right.png" alt />
          </span>
        </div>
        <div class="switch" v-if=" tourList == 4 || tourList == 5 ">
          <span @click="prev(4)">
            <img src="../../../assets/images/company/left.png" alt />
          </span>
          <span @click="next(5)">
            <img src="../../../assets/images/company/right.png" alt />
          </span>
        </div>
      </div>
      <div class="tourList">
        <ul v-if="tourList == 0">
          <li v-for="(item, i) in outboundTour01" :key="i">
            <img :src="item" alt />
          </li>
        </ul>
        <ul v-if="tourList == 1">
          <li v-for="(item, i) in outboundTour02" :key="i">
            <img :src="item" alt />
          </li>
        </ul>
        <ul v-if="tourList == 2">
          <li v-for="(item, i) in domesticTour01" :key="i">
            <img :src="item" alt />
          </li>
        </ul>
        <ul v-if="tourList == 3">
          <li v-for="(item, i) in domesticTour02" :key="i">
            <img :src="item" alt />
          </li>
        </ul>
        <ul v-if="tourList == 4">
          <li v-for="(item, i) in newYearMeeting01" :key="i">
            <img :src="item" alt />
          </li>
        </ul>
        <ul v-if="tourList == 5">
          <li v-for="(item, i) in newYearMeeting02" :key="i">
            <img :src="item" alt />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import anime from 'animejs'
export default {
  data() {
    return {
      tourMenuList: [
        { name: '出境游' },
        { name: '国内游' },
        { name: '新年会' }
      ],
      active: 1,
      // 出境游列表1
      outboundTour01: [
        require('../../../assets/images/join/welfare/outboundTour/2013yuenan.png'),
        require('../../../assets/images/join/welfare/outboundTour/2015taiguo.png'),
        require('../../../assets/images/join/welfare/outboundTour/2017feilvbin.png')
      ],
      // 出境游列表2
      outboundTour02: [
        require('../../../assets/images/join/welfare/outboundTour/2018taiguo.png'),
        require('../../../assets/images/join/welfare/zw.png'),
        require('../../../assets/images/join/welfare/zw.png')
      ],
      // 国内游列表1
      domesticTour01: [
        require('../../../assets/images/join/welfare/domesticTour/emeishantuanjian.png'),
        require('../../../assets/images/join/welfare/domesticTour/fuyoushantuanjian.png'),
        require('../../../assets/images/join/welfare/domesticTour/xilingxueshantuanjian.png')
      ],
      // 国内游列表1
      domesticTour02: [
        require('../../../assets/images/join/welfare/domesticTour/2016tuanjian.png'),
        require('../../../assets/images/join/welfare/zw.png'),
        require('../../../assets/images/join/welfare/zw.png')
      ],
      newYearMeeting01: [
        require('../../../assets/images/join/welfare/newYearMeeting/2013nianhui.png'),
        require('../../../assets/images/join/welfare/newYearMeeting/2014nianhui.png'),
        require('../../../assets/images/join/welfare/newYearMeeting/2015ninahui.png')
      ],
      newYearMeeting02: [
        require('../../../assets/images/join/welfare/newYearMeeting/2016ninahui.png'),
        require('../../../assets/images/join/welfare/newYearMeeting/2017nianhui.png'),
        require('../../../assets/images/join/welfare/newYearMeeting/2018nianhui.png')
      ],
      tourList: 0
    }
  },
  created() {},
  methods: {
    // 旅游列表切换函数
    setTourList(index) {
      // 切换线位置
      this.tourMenu(index)
      // 复位页面
      this.active = 1
    },
    // 左右切换
    prev(index) {
      this.tourList = index
      if ((this.active === 2)) {
        this.active--
      }
    },
    next(index) {
      this.tourList = index
      if ((this.active === 1)) {
        this.active++
      }
    },
    // 选中线移动函数
    menuSelection(width) {
      anime({
        targets: '.tourMenuList .selectLine',
        width: width
      })
    },
    // 判断选中线移动到指定位置
    tourMenu(index) {
      if (index === 0) {
        this.menuSelection('65px')
        this.tourList = 0
      } else if (index === 1) {
        this.menuSelection('150px')
        this.tourList = 2
      } else if (index === 2) {
        this.menuSelection('240px')
        this.tourList = 4
      }
    }
  }
}
</script>

<style scoped>
.welfare {
  margin: 30px auto;
  width: 100%;
  max-width: 1100px;
}
.welfare .culture {
  width: 100%;
  background-color: #fff;
  padding: 20px;
  box-sizing: border-box;
}
.welfare .culture .title {
  width: 100%;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  margin-top: 20px;
  position: relative;
}
.welfare .culture .title::after {
  content: '';
  width: 50px;
  height: 6px;
  position: absolute;
  bottom: -20px;
  left: 50%;
  transform: translate(-50%, 0);
  background-color: rgb(235, 89, 25);
}
.welfare .culture .icon {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 30px;
}
.welfare .culture .icon > div {
  position: relative;
  text-align: center;
  margin: 0 10px;
}
@media screen and (max-width: 849px) {
  .welfare .culture .icon > div {
    width: 90px;
    height: 100px;
  }
}
@media screen and (min-width: 850px) {
  .welfare .culture .icon > div {
    width: 90px;
    height: 100px;
  }
}
.welfare .culture .icon div img {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
}
.welfare .culture .icon > div div {
  position: absolute;
  width: 100px;
  left: 50%;
  bottom: 0;
  transform: translate(-50%, 0);
  word-break: keep-all;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 旅游板块 */
.welfare .tour {
  margin: 30px auto;
  width: 100%;
  max-width: 1100px;
  background-color: #fff;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.welfare .tour .tourMenu {
  width: 100%;
  max-width: 280px;
  margin-bottom: 20px;
}
.welfare .tour .tourMenu .tourMenuList {
  width: 100%;
  font-size: 22px;
  position: relative;
}
.tourMenu .tourMenuList ul {
  display: flex;
  justify-content: left;
}
.tourMenu .tourMenuList ul li {
  margin-right: 20px;
  cursor: pointer;
}
.tourMenu .tourMenuList .selectLine {
  position: absolute;
  bottom: -12px;
  width: 65px;
  height: 6px;
  background-color: rgb(235, 89, 25);
}
.tourMenu .number {
  display: inline-block;
  margin-top: 20px;
  font-size: 30px;
  font-weight: 400;
}
.tourMenu .number strong {
  font-size: 38px;
  font-weight: 600;
}
.tourMenu .switch {
  margin-top: 30px;
  width: 100px;
  background-color: rgb(235, 89, 25);
  height: 40px;
}
.tourMenu .switch span {
  display: inline-block;
  width: 50%;
  height: 100%;
  position: relative;
}
.tourMenu .switch span:hover {
  background-color: #727272;
}
.tourMenu span img {
  width: 24px;
  height: 24px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.tourList {
  width: 100%;
  max-width: 780px;
}
.tourList ul {
  width: 100%;
  display: flex;
  justify-content: left;
  flex-wrap: wrap;
}
@media screen and (min-width: 850px) {
  .tourList li {
    width: 260px;
    height: 180px;
    padding: 0 5px;
    box-sizing: border-box;
  }
}
@media screen and (max-width: 849px) {
  .tourList li {
    width: 100%;
    height: 240px;
    padding: 0 5px;
    box-sizing: border-box;
  }
}

.tourList li img {
  width: 100%;
}
</style>
